// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"347aac58","703":"64f8ed6b"}[chunkId] + ".chunk.js";
};